import i18next from 'i18next';
import { put, call } from '@redux-saga/core/effects';
import { isApiError, requestPuppy, XhrResponse } from '@wix/da-http-client';
import {
  PapiDaSharedDeviationFetch,
  PapiDeviation,
  PapiRequestDaSharedDeviationFetch,
} from '@wix/da-papi-types';

import { normalizeDeviation } from '../redux/normalizr/helpers';
import { putEntities } from '../redux/entities/actions';

import { addErrorNotification } from '../Notifications/redux/actionCreators';

// Show error notification
export function putErrorNotification(message) {
  return put(addErrorNotification(message));
}

// Fake deviation fetch, used by fetchDeviation
const fakeDeviationFetch = options => {
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line
    const { deviationsByType } = require('@wix/da-sample-data');
    return ({
	...deviationsByType.image[0],
	deviationId: options.params.deviationid
});
  }
};

// Fetch a deviation from the server
export function* fetchDeviation(deviationid: number) {
  const params: PapiRequestDaSharedDeviationFetch = {
    deviationid,
    type: 'art',
  };
  const response: XhrResponse<PapiDaSharedDeviationFetch> = yield call(
    requestPuppy,
    {
      method: 'get',
      url: '/deviation/fetch',
      params: params,
    },
    fakeDeviationFetch
  );

  if (!response || isApiError(response) || (response as any).errorCode === 0) {
    yield putErrorNotification(i18next.t('watch.undoRemove.error'));
    return;
  }
  const deviation = response as PapiDeviation;

  yield call(putDeviation, deviation);
  return deviation;
}

// Normalize the deviation and put it in the redux store
export function* putDeviation(deviation: PapiDeviation) {
  const entities = normalizeDeviation(deviation);
  if (entities) {
    yield put(putEntities({ entities }));
  }
}
